// extracted by mini-css-extract-plugin
export var bold = "_xd-0";